export const useSubscription = (match) => {
  
    // 🔹 Récupère la plus faible subscription entre home et away
    const homeSubscription = match?.homeTeam?.subscription ?? 1;
    const awaySubscription = match?.awayTeam?.subscription ?? 1;
    const subscriptionMatch = Math.min(homeSubscription, awaySubscription);
  
    // 🔥 Fonction pour vérifier si un composant peut être affiché
    const checkSubscription = (componentSubscription) => {
      return componentSubscription >= subscriptionMatch;
    };
  
    return { checkSubscription, subscriptionMatch };
  };